export default __webpack_public_path__ + "static/media/roof-top-unit.48979ff8.jpg";